<template>
  <div id="searchCondition">
    <h1>{{ $t("Search.title") }}</h1>
<!-- 保留
    <div id="howto">
      <a v-on:click="externalLink">{{ $t("Search.howto") }}</a>
    </div>
-->
    <!-- 検索条件 (必須) -->
    <table>
    <thead>
      <tr>
        <th colspan=4>{{ $t("Search.Required.title") }}</th>
      </tr>
    </thead>
    <tbody>
    <tr v-if="sales"><!-- 国/販売会社コード（販売店ユーザー）-->
      <th class="item"><p v-html="$t('Search.Required.distCode')"></p></th>
      <td width="182px">{{ params.distCd }}</td>
      <th class="item"></th>
      <td></td>
    </tr>
    <tr v-else><!-- 国/販売会社コード（開発者ユーザー）-->
      <th class="item"><p v-html="$t('Search.Required.distCode')"></p></th>
      <td>
        <input type="text" class="search_required_text" v-model="params.distCd" id="distCd" :placeholder="$t('Common.requiredEx')" autocomplete="on">
      </td>
    </tr>
    <tr><!-- 年月日  -->
      <th class="item"><p v-html="$t('Search.Required.date')"></p></th>
      <td colspan="3">
        <table id="searchDate">
        <tr>
          <td width='110px'>
            <calender
              v-model="params.date_from"
              :language="this.$i18n.locale"
              :value="params.date_from"
              :limitDay="new Date(limitDay)"
            />
          </td>
          <td width='30px'>～</td>
          <td width='80px'>{{ getDateView(date_to) }}</td>
          <td></td>
        </tr>
        </table>
      </td>
    </tr>
    </tbody>
    </table>
    <br>

    <!-- 検索条件 (任意) -->
    <table>
    <thead>
      <tr>
        <th colspan=4>{{ $t("Search.Option.title") }}</th>
      </tr>
    </thead>
    <tbody>
    <tr><!-- ディーラーコード  -->
      <th class="item"><p v-html="$t('Search.Option.dealerCode')"></p></th>
      <td><input type="text" class="search_text" v-model="params.dealer_code" id="dealer_code" :placeholder="$t('Search.Option.dealerCodeEx')"></td>
      <th class="item"></th>
      <td></td>
    </tr>
    <tr><!-- 担当者名  -->
      <th class="item"><p v-html="$t('Search.Option.staffName')"></p></th>
      <td><input type="text" class="search_text" v-model="params.staff_name" id="staff_name" :placeholder="$t('Search.Option.staffNameEx')"></td>
      <th></th>
      <td></td>
    </tr>
    <tr><!-- 車両名(GTS+登録名)/車両型式  -->
      <th class="item_return"><p v-html="$t('Search.Option.vehicleName')"></p></th>
      <td><input type="text" class="search_text" v-model="params.vehicle_name" id="vehicle_name" :placeholder="$t('Search.Option.vehicleNameEx')"></td>
      <th class="item"><p v-html="$t('Search.Option.model')"></p></th>
      <td><input type="text" class="search_text" v-model="params.model" id="model" :placeholder="$t('Search.Option.modelEx')"></td>
    </tr>
    <!-- ステータス -->
    <tr>
      <th class="item"><p v-html="$t('Search.Option.status')"></p></th>
      <td colspan="3">
        <label for="not_requested">
          <input type="checkbox" id="not_requested" value="1" v-model="params.status">{{ $t("Common.statusItem.notRequested") }}
        </label>
        <label for="submitted">
          <input type="checkbox" id="submitted" value="2" v-model="params.status">{{ $t("Common.statusItem.submitted") }}
        </label>
        <label for="pending">
          <input type="checkbox" id="pending" value="3" v-model="params.status">{{ $t("Common.statusItem.pending") }}
        </label>
      </td>
    </tr>
    </tbody>
    </table>
    <br>

  <!-- 検索ボタン -->
    <table class="button">
    <tr>
      <td width="60%"></td>
      <td><button v-on:click="doClear" class="clear">{{ $t("Search.Button.clear") }}</button></td>
      <td><button v-on:click="doSearch" class="search" :disabled="searching">{{ $t("Search.Button.search") }}</button></td>
    </tr>
    </table>
    <br>

  <!-- 検索結果 -->
    <table>
      <thead>
        <tr>
          <th colspan="6">{{ $t("Search.Result.title") }}</th>
        </tr>
      </thead>
    </table>
    <!-- メッセージ -->
    <table class="msgT" v-if="searching || resultError > 0 || number > -1">
    <tr>
      <td class="msgNum" v-if="number > -1">{{ getNumber }}</td>
      <td class="msg" v-bind:style="stylesMessage">{{ getMsg }}</td>
    </tr>
    </table>
    <!-- 結果一覧 -->
    <table class="resultList" v-if="!searching">
      <thead>
      <tr>
        <th class="no">{{ $t("Search.Result.no") }}</th>
        <th class="datetime">{{ $t("Search.Result.dateTime") }}</th>
        <th class="dealername">{{ $t("Search.Result.dealerName") }}</th>
        <th class="vehiclename">{{ $t("Search.Result.vehicleName") }}</th>
        <th class="status">{{ $t("Search.Result.status") }}</th>
        <th class="detail">{{ $t("Search.Result.link") }}</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="item in datalists" v-bind:key="item.no">
          <td class="no">{{ item.no }}</td>
          <td class="datetime">{{ item.datetime }}</td>
          <td class="dealername">{{ item.dealerName }}</td>
          <td class="vehiclename">{{ item.vehicleName }}</td>
          <td class="state" v-if="item.zendeskNo === ''">{{ getStatus(item.requestStatus) }}</td>
          <td class="state" v-else>{{ getStatus(item.requestStatus) }}({{ item.zendeskNo }})</td>
          <td class="detail">
            <button v-on:click="doDetail(item.no)">
              {{ $t("Search.Result.detail") }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment" // 日付フォーマット
import Calender from './calender.vue';
import CONST from '../const/const.js'  // 定数

export default {
  name: 'Search',
  data () {
    return {
      // 検索条件項目-初期値
      params: {
        distCd: '',
        date_from: '',
        dealer_code: '',
        staff_name: '',
        vehicle_name: '',
        model: '',
        status: [CONST.STATUS.NOT_REQUESTED],
      },
      date_from_default: '',
      date_to: new Date(),
      limitDay: '',
      sales: false,  // true:販売店ユーザー、false:開発ユーザー
      searching: false, // true:検索中、false:検索中ではない（メッセージ表示＆多重送信防止）
      resultError: CONST.SEARCH.ERROR.NOT_ERROR,   // 0:エラー無、1以上:エラー有
      stylesMessage: {
        color: 'black', // 検索中:black、エラー:red
      },
      number: -1, // -1:検索結果無、0以上:結果有
      // 検索結果一覧
      datalists:[],
    }
  },

  /*
   * components: 子コンポーネント
   */
  components: {
    Calender,
  },

  /*
   * created: 初期処理
   */
  created : function(){
    // 年月日From
    var dt = new Date();
    dt.setDate(dt.getDate() - CONST.CALENDER_DAYS.DAY_DEFAULT);
    this.date_from_default = dt;
    this.params.date_from = this.date_from_default;

    // 年月日入力制限
    var dtl = new Date();
    dtl.setDate(dtl.getDate() - CONST.CALENDER_DAYS.DAY_LIMIT - 1);
    this.limitDay = dtl;
  },

  /*
   * mounted: elementへのマウント
   */
  mounted : function() {
    // 前回の検索パラメータを取得して設定を行う
    // 詳細→検索に戻ってきた場合
    if(Object.prototype.hasOwnProperty.call(sessionStorage, 'search-params-condition')) {
      var params = JSON.parse(sessionStorage.getItem('search-params-condition'));
      if (params.date_from) {
        params.date_from = new Date(params.date_from);
      }
      this.params = params;
    }

    // サインインユーザ判定
    if(this.$store.state.user['group'] === CONST.USER_KBN.DEVELOP) {
      this.sales = false;
    } else {
      this.sales = true;
      this.params.distCd = this.$store.state.user['custom:distCode']
    }

    // 検索結果一覧
    if(Object.prototype.hasOwnProperty.call(sessionStorage, 'search-result-list')) {
      this.datalists = JSON.parse(sessionStorage.getItem('search-result-list'));
      this.number = this.datalists.length;
    }
//console.log(this.$store.state.user);
  },

  /*
   * methods: メソッド
   */
  methods: {
    // 検索ボタン押下
    doSearch: function() {
      // 認証チェック
      this.$cognito.isAuthenticated().then(session => {
        this.searching = true;
        // リセット処理
        // 検索条件のセッションストレージをクリア
        sessionStorage.removeItem('search-params-condition');
        // 結果一覧を初期化
        this.datalists = [];
        sessionStorage.removeItem('search-result-list');
        // 各設定値をリセット
        this.stylesMessage.color = 'black';
        this.resultError = CONST.SEARCH.ERROR.NOT_ERROR;
        this.number = -1;

        // 国/販売会社コード必須入力チェック
        if (this.params.distCd.length < 1) {
          this.stylesMessage.color = 'red';
          this.resultError = CONST.SEARCH.ERROR.INPUT_ERROR;
          this.searching = false;
          return;
        }

        // セッションストレージに検索条件を格納
        sessionStorage.setItem('search-params-condition', JSON.stringify(this.params));

        // Json形式の検索条件を取得
        var jsonStr = this.getPostJson();
//console.log(JSON.stringify(jsonStr));
//console.log(this.$store);
//console.log(session);
        // IDトークンによるアクセス認可用ヘッダーを生成
        var header = {
          headers: {
            "Authorization": session.idToken.jwtToken
          }
        }

        // API GatewayへPostして検索を実行する
        this.$axios.post('/', jsonStr, header).then(response => {
//console.log(response);
          var responseData = JSON.parse(response.data);

          // 正常終了
          if (responseData.statusCode === 200) {
            //this.number = 500;
            this.number = responseData.Count;
//console.log(this.number);
            // 件数チェック
            if (this.number === 0) {
              this.stylesMessage.color = 'red';
              this.resultError = CONST.SEARCH.ERROR.RESULT_0_ERROR;
            } else if (this.number > CONST.SEARCH.MAX_RECORD) {
              this.stylesMessage.color = 'red';
              this.resultError = CONST.SEARCH.ERROR.RESULT_MAX_ERROR;
              this.number = CONST.SEARCH.MAX_RECORD;
            }

            responseData.Items.forEach((val, index) => {
              // 画面表示件数は500件まで
              if (index < CONST.SEARCH.MAX_RECORD) {
                // 日付を加工
                var s = val.error_id;
                var d = s.slice(0, 4) + '-' + s.slice(4, 6) + '-' + s.slice(6, 8);
                var t = s.slice(8, 10) + ':' + s.slice(10, 12) + ':' + s.slice(12, 14);
                // UTC日時で設定
                var date_utc = new Date(d + 'T' + t + 'Z');
console.log(date_utc);
                // YYYY/MM/DD HH:mmに変換
                var date_format = date_utc.getFullYear() + '/' + ('0' + (date_utc.getMonth() + 1)).slice(-2) + '/' +('0' + date_utc.getDate()).slice(-2) + ' ' +  ('0' + date_utc.getHours()).slice(-2) + ':' + ('0' + date_utc.getMinutes()).slice(-2);

                var listData = {
                  "id": val.id,
                  "errorId": val.error_id,
                  "no": index + 1,
                  "datetime": date_format,
                  "dealerName": val.dealer_name,
                  "vehicleName": val.vehicle_name,
                  "requestStatus": val.request_status,
                  "zendeskNo": val.zendesk_no,
                };
                this.datalists.push(listData);
              }
            });

            // セッションストレージに検索結果を格納
            sessionStorage.setItem('search-result-list', JSON.stringify(this.datalists));
var list = JSON.parse(sessionStorage.getItem('search-result-list'));
console.log(list);

          // パラメータ不正場合 又は Lambdaが異常終了した場合
          } else if(responseData.statusCode === 400 || responseData.statusCode === 500) {
            this.stylesMessage.color = 'red';
            this.resultError = CONST.SEARCH.ERROR.SEARCH_ERROR;
            console.log('パラメータ不正、又は処理が異常終了しました');
          }
        })

        // Postエラーの場合
        .catch(error => {
          this.stylesMessage.color = 'red';
          this.resultError = CONST.SEARCH.ERROR.NETWORK_ERROR;
          console.log(error);
        }).finally(v=>{  // eslint-disable-line
          this.searching = false;
        });
      })

      // Cognitoの認証エラーの場合
      .catch(error => { // eslint-disable-line
console.log('検索画面 - 認証エラー');
        this.moveSigninPage();
      })
    },

    // 検索用Json生成
    getPostJson() {
      var fromDate = '0';
      var toDate = '99999999'; // 8桁
      fromDate = moment(this.params.date_from).format("YYYYMMDD");
      if (this.date_to) {
        toDate = moment(this.date_to).format("YYYYMMDD");
      }

      const nowDate = new Date();
      var dateString = nowDate.toTimeString().split('GMT');
//console.log(dateString[1].substr(0, 5));

      // ステータスを文字列に変換
      var statusStr = '';
      if ((this.params.status.length > 0)) {
        statusStr = this.params.status[0];
        for (let i = 1; i < this.params.status.length; i++) {
          statusStr += ',' + this.params.status[i];
        }
      }

      return {
        mode: CONST.ACTION_MODE.SEARCH,
        id: this.params.distCd,
        fromDate: fromDate,
        toDate: toDate,
        timeDifference: dateString[1].substr(0, 5),
        dealerCode: this.params.dealer_code,
        staffName: this.params.staff_name,
        vehicleName: this.params.vehicle_name,
        model: this.params.model,
        requestStatus: statusStr
      };
    },

    // クリアボタン押下
    doClear: function() { // eslint-disable-line
      this.searching = false;
      this.resultError = CONST.SEARCH.ERROR.NOT_ERROR;
      this.number = -1;

      // 検索結果一覧クリア
      this.datalists = [];

      // セッションストレージをクリア
      sessionStorage.removeItem('search-params-condition');
      sessionStorage.removeItem('search-result-list');

      // 必須検索条件クリア
      if (!this.sales) {
        // 開発者がログインした場合はクリア
        this.params.distCd = '';
      }

      // 任意検索条件クリア
      this.params = {
        distCd: this.params.distCd, // 必須項目はクリアしない
        date_from: this.date_from_default,
        dealer_code: '', // その他任意項目はクリア
        staff_name: '',
        vehicle_name: '',
        model: '',
        status: [CONST.STATUS.NOT_REQUESTED], // ステータスは未処理に戻す
      }
    },

    // 詳細ボタン押下
    doDetail: function(no) {
      this.$router.push({
        name: 'Detail',
        params: {
          no: no
        },
      });
    },

    // サインインページ遷移
    moveSigninPage() {
      var home = '';// eslint-disable-line
      if(this.$store.state.user) {
        if(this.$store.state.user['group'] === CONST.USER_KBN.DEVELOP) {
          home = '/signin/0';
        } else {
          home = '/kitora/403';
        }
      }

      this.$store.commit('setUser', null)
      this.$cognito.signout();
      this.$router.push(home);
    },

    // 外部サイトを開く
    externalLink() {
      const url = this.$t("Search.howtoLink")
      //window.location.href = url;
      window.open(url, '_blank');
    }
  },

  /*
   * computed: 算出プロパティ
   */
  computed: {
    // 日付フォーマット表示
    getDateView: function() {
      return function(val) {
        return moment(val).format("YYYY/MM/DD");
      }
    },
    // 取得件数
    getNumber: function() {
      var str = '';
      if (this.number > -1) {
        str = this.number + this.$t("Search.Result.num");
      }
      return str;
    },
    // 検索結果メッセージ
    getMsg: function() {
      // 検索中...
      if (this.searching) {
        return this.$t("Message.MSG002");
      }

      // エラー
      if (this.resultError !== CONST.SEARCH.ERROR.NOT_ERROR) {
        switch (this.resultError) {
          case CONST.SEARCH.ERROR.INPUT_ERROR: // 必須入力エラー
            return this.$t("Message.MSG003");
          case CONST.SEARCH.ERROR.SEARCH_ERROR: // Lambda400 or 500エラー
            return this.$t("Message.MSG006");
          case CONST.SEARCH.ERROR.NETWORK_ERROR: // Postエラー
            return this.$t("Message.MSG009");
          case CONST.SEARCH.ERROR.RESULT_0_ERROR: // 検索結果０件
            return this.$t("Message.MSG005");
          case CONST.SEARCH.ERROR.RESULT_MAX_ERROR: // 検索結果オーバー
            return this.$t("Message.MSG004");
          default:
        }
      }

      // エラーなし
      return "";
    },
    // ステータス文字列取得
    getStatus: function() {
      return function(val) {
        switch (val) {
          case CONST.STATUS.NOT_REQUESTED: // 未処理（東京リージョン）
            return this.$t("Common.statusItem.notRequested");
          case CONST.STATUS.SUBMITTED: // 報告済（東京リージョン）
            return this.$t("Common.statusItem.submitted");
          case CONST.STATUS.PENDING: // 報告せず（東京リージョン）
            return this.$t("Common.statusItem.pending");
          default:
            return '';
        }
      }
    },
  },
}
</script>

<style lang="scss">
/*--------------------
   BASIC CLASSES
--------------------*/
#searchCondition {
  max-width: 640px;
  margin: 0 auto;
}

#howto {
  a {
    font-weight: bold;
    color: #00aaff;
    text-decoration: underline;
    line-height: 30px;
  }

  a:hover  {
    color:#0033cc;
    cursor: pointer;
  }
}

#searchDate {
  max-width: 490px;
  border: 0px solid #000000;
}

/*--------------------
   FORM STYLING
--------------------*/
/* SEARCH CONDITION */
tbody th.item {
  width: 140px;
  color: #00bfff;
}
tbody th.item_return {
  width: 140px;
  color: #00bfff;
}
input.search_required_text {
  width: 130px;
}
  .search_required_text::placeholder {
    color: #bbb;
    font-style: italic;
    text-align: center;
//    font-size: 11px;
  }
  // オートコンプリート対策
  .search_required_text:-webkit-autofill {
    box-shadow: 0 0 0 1000px white inset;
  }
input.search_text {
  width: 100px;
}
  .search_text::placeholder {
    color: #bbb;
    font-style: italic;
  }
  .search_text:-webkit-autofill {
    box-shadow: 0 0 0 1000px white inset;
  }

/* SEARCH BUTTON */
.search {
  background-color: #ffa500;
  width: 120px;
}
.clear {
  background-color: #696969;
  width: 120px;
}

.msgT {
  border: none;
}

.msgNum {
  text-align: left;
  line-height: 22px;
  width: 50px;
}

.msg {
  text-align: left;
  line-height: 22px;
  boder: none;
}

/* SEARCH RESULT */
.resultList th,
.resultList td {
  background-color: #ffffff;
  border: 1px solid #a9a9a9;
  color: #000000;
  font-size: 13px;
}
.resultList th.no,
td.no {
  width: 36px;
  text-align: center;
}
.resultList th.datetime,
td.datetime {
  width: 110px;
  text-align: cente;
}
.resultList th.dealername,
  td.dealername {
    width: 159px;
    text-align: left;
}
.resultList th.vehiclename,
td.vehiclename {
  width: 150px;
  text-align: left;
}
.resultList th.status,
td.status {
  width: 125px;
  text-align: left;
}
.resultList th.detail,
td.detail {
  width: 60px;
  text-align: center;
}
.resultList button {
  font-size: 13px;
  border: none;
  border-radius: 5px;
  width: 50px;
  line-height: 24px;
  padding: 0 8px;
  background: #0099e4;
  color: #fff;
  cursor: pointer;
}
</style>
